import type { ICellRendererParams } from 'ag-grid-community';

export interface UserNameCellProps {
  first: string;
  last: string;
}

/**
 * This cell-renderer renders a circle with the first letter of the first and last name of the user as well as the
 * user's name
 */
export const UserNameCellRenderer = (props: ICellRendererParams<any, UserNameCellProps>) => {
  if (!props?.value) return null;
  const { first, last } = props.value;
  return (
    <div className="tw:flex tw:flex-col tw:items-center">
      <div className="tw:mr-sq-5 tw:flex tw:h-[30px] tw:min-h-[30px] tw:w-[30px] tw:min-w-[30px] tw:flex-col tw:items-center tw:justify-center tw:rounded-full tw:bg-sq-theme-dark tw:text-center tw:text-[small] tw:text-sq-white">
        {first?.substring(0, 1)}
        {last?.substring(0, 1)}
      </div>
      {first && first} {last && last}
    </div>
  );
};
